import { getAudioContext } from './audioContext'

/**
 * Der Denk-Ton: Zwischen Frage und erstem Wort vergehen im Sprachmodus
 * manchmal zwei, drei Sekunden. Stille fühlt sich dabei an wie „geht nicht".
 * Nach kurzer Wartezeit klingt deshalb ein leiser, nachdenklicher Ton —
 * zwei weiche Sinustöne, eine kleine Terz aufwärts, langsam an- und
 * abschwellend. Kein Piepen, eher ein „Hm" ohne Stimme. Sobald K4ia spricht,
 * wird er nicht mehr gebraucht und verklingt.
 */
export const DENKTON_NACH_MS = 900

const LAUTSTAERKE = 0.05
const DAUER_S = 0.9

export function playThinkingTone(): () => void {
  let ctx: AudioContext
  try {
    ctx = getAudioContext()
  } catch {
    return () => {}
  }
  if (ctx.state !== 'running') return () => {}

  const jetzt = ctx.currentTime
  const master = ctx.createGain()
  master.gain.setValueAtTime(0, jetzt)
  master.gain.linearRampToValueAtTime(LAUTSTAERKE, jetzt + 0.18)
  master.gain.setTargetAtTime(0, jetzt + DAUER_S * 0.55, 0.16)
  master.connect(ctx.destination)

  // G4 und B4 (kleine Terz), die zweite kommt etwas später dazu — das gibt dem
  // Ton die „nachdenkliche" Bewegung.
  const stimmen = [
    { hz: 392, ab: 0 },
    { hz: 466.16, ab: 0.22 },
  ]
  const oszillatoren = stimmen.map(({ hz, ab }) => {
    const osc = ctx.createOscillator()
    osc.type = 'sine'
    osc.frequency.setValueAtTime(hz, jetzt)
    const gain = ctx.createGain()
    gain.gain.setValueAtTime(0, jetzt + ab)
    gain.gain.linearRampToValueAtTime(1, jetzt + ab + 0.15)
    osc.connect(gain)
    gain.connect(master)
    osc.start(jetzt + ab)
    osc.stop(jetzt + DAUER_S + 0.6)
    return osc
  })

  let gestoppt = false
  return () => {
    if (gestoppt) return
    gestoppt = true
    const t = ctx.currentTime
    master.gain.cancelScheduledValues(t)
    master.gain.setValueAtTime(master.gain.value, t)
    master.gain.linearRampToValueAtTime(0, t + 0.08)
    for (const osc of oszillatoren) {
      try {
        osc.stop(t + 0.1)
      } catch {
        /* schon zu Ende */
      }
    }
  }
}
